module.exports = __webpack_public_path__ + "img/portfolio-details.c0cb6640.png";